import { render, staticRenderFns } from "./TableRowVialsTotalNewPatients.vue?vue&type=template&id=7dc002e1&lang=pug&"
import script from "./TableRowVialsTotalNewPatients.vue?vue&type=script&lang=js&"
export * from "./TableRowVialsTotalNewPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc002e1')) {
      api.createRecord('7dc002e1', component.options)
    } else {
      api.reload('7dc002e1', component.options)
    }
    module.hot.accept("./TableRowVialsTotalNewPatients.vue?vue&type=template&id=7dc002e1&lang=pug&", function () {
      api.rerender('7dc002e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/performance-evaluation/table-rows/TableRowVialsTotalNewPatients.vue"
export default component.exports